// Browser-only shader registry. scripts/build-browser.mjs configures esbuild's
// `loader: { ".wgsl": "text" }` so each import below resolves to the file's
// raw source, inlined straight into the bundled script.

import complex from "./helpers/complex.wgsl";
import viewport from "./helpers/viewport.wgsl";
import palette from "./helpers/palette.wgsl";
import mandelbrot from "./fractals/mandelbrot.wgsl";
import julia from "./fractals/julia.wgsl";
import burningship from "./fractals/burningship.wgsl";
import tricorn from "./fractals/tricorn.wgsl";
import multibrot from "./fractals/multibrot.wgsl";
import newton from "./fractals/newton.wgsl";
import mandelbrotF64 from "./fractals/f64/mandelbrot.wgsl";

// Double-double (f64) primitives — src/shaders/f64/, vendored from wgblas
// plus this app's own ComplexDD API (subtract/complex/viewport.wgsl) on top.
// Only pulled in by f64-precision formula variants (see pipeline.mjs's
// F64_MODULES). abs.wgsl/equal.wgsl aren't imported — unused by Mandelbrot.
import f64Dekker from "./f64/dekker.wgsl";
import f64Add from "./f64/utils/add.wgsl";
import f64Multiply from "./f64/utils/multiply.wgsl";
import f64Subtract from "./f64/utils/subtract.wgsl";
import f64Greater from "./f64/utils/greater.wgsl";
import f64Complex from "./f64/complex.wgsl";
import f64Viewport from "./f64/viewport.wgsl";

/**
 * `complex`, `viewport`, and `palette` are prepended to every other entry at
 * pipeline-compile time (see src/util/pipeline.mjs) — together they supply
 * the Complex type and arithmetic, `pixelToComplex`, and the `colorize*`
 * functions that every formula shader calls but none of them redefines.
 * @module wgfractals/shaders/registry
 */
export const shaderSources = {
  complex,
  viewport,
  palette,
  mandelbrot,
  julia,
  burningship,
  tricorn,
  multibrot,
  newton,
  "f64/mandelbrot": mandelbrotF64,
  "f64/dekker": f64Dekker,
  "f64/utils/add": f64Add,
  "f64/utils/multiply": f64Multiply,
  "f64/utils/subtract": f64Subtract,
  "f64/utils/greater": f64Greater,
  "f64/complex": f64Complex,
  "f64/viewport": f64Viewport,
};
